import { useEffect } from "react"

type Props = {
    buttonId: string
    dialogId: string
}

export default function ({ buttonId, dialogId }: Props) {
    useEffect(() => {
        const buttons = document.querySelectorAll(`#${buttonId}`)
        const dialog = document.getElementById(dialogId) as HTMLDialogElement

        if (!dialog) return

        const open = () => dialog.showModal()
        for (const button of buttons) button.addEventListener('click', open)
        return () => {
            for (const button of buttons) button.removeEventListener('click', open)
        }
    }, [buttonId, dialogId])

    return null
}
